module.exports = __webpack_public_path__ + "static/media/bd.360ae045.webp";